import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/components/student/PageHeader";
import { Colors, useLayoutCommon } from "@/contexts/LayoutContext";
import { usePrivate } from "@/contexts/PrivateContext";
import { AuthRole } from "@/services/shared/auth/auth.interfaces";
import { LevelTestStates } from "@/services/student/level-test.interfaces";

export const LevelTestGate: React.FC = () => {
  const { setBackgroundColor } = useLayoutCommon();
  const navigate = useNavigate();
  const { isLoaded, isLoggedIn, role, levelTestState } = usePrivate();

  useEffect(() => {
    setBackgroundColor(Colors.WHITE);
  }, [setBackgroundColor]);

  useEffect(() => {
    if (!isLoaded || !isLoggedIn || role !== AuthRole.Student) return;

    switch (levelTestState) {
      case LevelTestStates.InProgress:
        navigate("/student/level-test/test", { replace: true });
        break;
      case LevelTestStates.Completed:
        navigate("/student/level-test/result", { replace: true });
        break;
      case LevelTestStates.Skipped:
        navigate("/student/dashboard", { replace: true });
        break;
      case LevelTestStates.Inactive:
      case LevelTestStates.Active:
      default:
        navigate("/student/level-test/welcome", { replace: true });
        break;
    }
  // Intencionalmente excluímos `navigate` do array para evitar reexecução desnecessária
  // de efeitos por funções imperativas. O comportamento desejado depende somente do estado.
  }, [isLoaded, isLoggedIn, role, levelTestState]);

  if (!isLoaded) {
    return (
      <div className="max-w-[1800px] w-full">
        <PageHeader
          showAvatar={true}
          showActions={true}
          title="Teste de Nivelamento"
        />
        <div className="w-full bg-gray-50 rounded-xl p-6 mt-6">
          <div className="w-[1227px] mx-auto">
            <div className="flex justify-center items-center py-12">
              <div className="text-gray-600 text-lg">Carregando...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};
